/**
 * @aparte/locale-fr
 *
 * French translations for aparté. Core ships English (`APARTE_DEFAULT_LOCALE`) by
 * default — pass this to `aparteGlobalConfig.setLocale(fr)` to switch.
 */

import type { AparteLocale } from '@aparte/core';

export const fr: AparteLocale = {
    inputPlaceholder: "Écrivez un message...",
    sendButton: "Envoyer",
    copy: "Copier",
    copied: "Copié !",
    retry: "Réessayer",
    thinking: "Réflexion en cours...",
    elicitationOther: "Autre…",
    elicitationOtherPlaceholder: "Écrivez votre réponse…",
    elicitationOtherLabel: "Réponse libre",
    submitButton: "Valider",
    stopButton: "Arrêter",
    elicitationRecommended: "Recommandé",
    elicitationSkip: "Passer",
    elicitationYes: "Oui",
    elicitationNo: "Non",
    elicitationAnswerLabel: "Votre réponse",
    approvalInstructionPlaceholder: "Ou dites-lui quoi faire à la place…",
    approvalOptionsLabel: "Votre décision",
    approvalArgsLabel: "Arguments",
    approvalAsk: "Exécuter {tool} ?",
    approvalWaiting: "En attente",
    scrollToBottom: "Aller en bas de la conversation",
    suggestionsLabel: "Suggestions de messages",
    contextLabel: "Fenêtre de contexte",
    compactionSummaryTitle: "Résumé de la conversation",
    toolRunning: "En cours",
    toolFailed: "Échec",
    toolCompleted: "Terminé",
    toolRejected: "Refusé",
    toolStopped: "Arrêté",
    toolInput: "Entrée",
    toolOutput: "Sortie",
    actionUpload: "Joindre un fichier",
    removeAttachment: "Retirer {name}",
    selectSearchPlaceholder: "Rechercher…",
    selectSearchLabel: "Rechercher parmi les options",
    loading: "Chargement…",
    download: "Télécharger",
    previewPending: "Appuyez sur Aperçu pour exécuter cet artefact.",
    sandboxError: "Le bac à sable a échoué pendant la génération.",
    sandboxErrorHint: "Cause fréquente : le modèle a produit du code invalide (variable non définie, mauvais type d'argument). Relancez la demande — le modèle peut produire un autre code.",
    preview: "Aperçu",
    code: "Code",
    generating: "Génération…",
    rebuildingPreview: "Reconstruction de l'aperçu…",
    typing: "Écrit...",
    error: "Erreur",
    running: "Exécution...",
    run: "Exécuter",
    file: "Fichier",
    modelSelectorPlaceholder: "Sélectionner un modèle...",
    approvalModeLabel: "Mode d'approbation",
    roleNameUser: "Vous",
    roleNameAssistant: "Assistant",
    yourMessage: "Votre message",
    assistantResponse: "Réponse de l'assistant",
    messageActions: "Actions du message",
    edit: "Modifier le message",
    editConfirm: "Envoyer",
    editCancel: "Annuler",
    feedbackPositive: "Bonne réponse",
    feedbackNegative: "Mauvaise réponse",
    previousResponse: "Réponse précédente",
    nextResponse: "Réponse suivante",
    approveTool: "Approuver",
    rejectTool: "Rejeter",
    messageInfo: "Détails",
    newChat: "Nouvelle conversation",
    loadingConversations: "Chargement des conversations",
    loadingConversation: "Chargement de la conversation",
    deleteConversation: "Supprimer",
    archiveConversation: "Archiver",
    unarchiveConversation: "Désarchiver",
    conversationActions: "Actions de la conversation",
    renameConversation: "Renommer",
    conversationTitle: "Titre de la conversation",
    pinConversation: "Épingler",
    unpinConversation: "Désépingler",
    deleteConversationConfirm: "Supprimer « {title} » ?",
    cancel: "Annuler",
    conversationGroupPinned: "Épinglées",
    conversationGroupToday: "Aujourd'hui",
    conversationGroupYesterday: "Hier",
    conversationGroupWeek: "7 derniers jours",
    conversationGroupMonth: "30 derniers jours",
    scrollRailLabel: "Plan de la conversation",
    sidebarLabel: "Conversations",
    splitHandleLabel: "Redimensionner les panneaux",
    transcript: "Transcription",
    tag: "fr-FR",
    direction: 'ltr'
};

export default fr;
